module.exports = __webpack_public_path__ + "img/about1.d50cac0.png";